export default __webpack_public_path__ + "static/media/ready-to-use strategy templates.3e576f4c.png";